/* eslint-disable no-console */
// TODO: enabling console.debug unitl $logger.debug function is fixed to be used in javascript files. It's too costly to just comment them out as we will not be able to track the flow of execution
import { CustomerSalesContractService } from "../_services/api/accounts/customer-sales-contract.service";

class CustomerSalesContracts {
  constructor() {
    this.CustomerSalesContractItems = [];
  }
  addContract(params) {
    this.CustomerSalesContractItems.push(new CustomerSalesContractItem(params));
  }
  drawProduct(
    soLineNo,
    itemCode,
    oldQty,
    newQty,
    oldSalesUM,
    newSalesUM,
    customerSalesContractCode,
    customerSalesContractLineNo,
    existingContractLineUsages
  ) {
    var qtyDiff = newQty - oldQty;
    var contractItem = null;

    var isSalesUMChanged = oldSalesUM !== newSalesUM;

    console.debug(
      `DrawProduct: SOLineNo:${soLineNo} Product:${itemCode}, OldQty: ${oldQty} NewQty:${newQty} OldSalesUM:${oldSalesUM} NewSalesUM:${newSalesUM} `
    );
    console.debug(
      `DrawProduct: Existing CustomerSalesContractCode:${customerSalesContractCode}, CustomerSalesContractLineNo:${customerSalesContractLineNo}`
    );
    // is prodict in contract
    var isInContract = this.CustomerSalesContractItems.find(
      (item) => item.ProductCode === itemCode
    );
    if (isInContract == null) {
      console.debug(
        `DrawProduct: ${itemCode} does not exist within CustomerSalesContractItems`
      );
      return null;
    }

    // draw product due to SalesUM change on Sales Order Line
    if (isSalesUMChanged) {
      // disassociate existing contract associations
      if (
        customerSalesContractCode != null &&
        customerSalesContractLineNo != null
      ) {
        console.debug(
          `DrawProduct: SalesUM changed from ${oldSalesUM} to ${newSalesUM}! Therefore Undraw oldQty:${oldQty} and disassociate the Contract:${customerSalesContractCode} and ContractLine:${customerSalesContractLineNo}`
        );

        this.updateBalance(
          itemCode,
          -1 * oldQty,
          oldSalesUM,
          customerSalesContractCode,
          customerSalesContractLineNo
        );
        customerSalesContractCode = null;
        customerSalesContractLineNo = null;
      }
    }

    // Quantity reduced while an existing contract association exists
    if (
      qtyDiff < 0 &&
      customerSalesContractCode != null &&
      customerSalesContractLineNo != null
    ) {
      // undraw this
      console.debug(
        `DrawProduct: Trying to Undraw from Contract:${customerSalesContractCode} and ContractLine:${customerSalesContractLineNo} because qtyDiff(${qtyDiff}) is negative`
      );
      contractItem = this.updateBalance(
        itemCode,
        qtyDiff,
        oldSalesUM,
        customerSalesContractCode,
        customerSalesContractLineNo
      );
      return {
        CustomerSalesContractCode:
          newQty == 0 ? null : customerSalesContractCode,
        CustomerSalesContractLineNo:
          newQty == 0 ? null : customerSalesContractLineNo,
        SalesContractItem: contractItem,
      };
    }
    // look to see if we can consume more of the same contract line
    if (customerSalesContractCode != null) {
      console.debug(
        `DrawProduct: Trying to Draw from same Contract:${customerSalesContractCode} and ContractLine:${customerSalesContractLineNo}`
      );
      const existingContractStillValidToUse = this.CustomerSalesContractItems.find(
        (item) =>
          item.CustomerSalesContractCode === customerSalesContractCode &&
          item.CustomerSalesContractLineNo === customerSalesContractLineNo &&
          item.ProductCode == itemCode &&
          item.SalesUM.toUpperCase() == oldSalesUM.toUpperCase() &&
          item.Balance >= qtyDiff
      );

      if (existingContractStillValidToUse != null) {
        console.debug(
          `DrawProduct: We still can Draw from same contract line hence update the balance!`
        );
        contractItem = this.updateBalance(
          itemCode,
          qtyDiff,
          oldSalesUM,
          customerSalesContractCode,
          customerSalesContractLineNo
        );
        return {
          CustomerSalesContractCode: customerSalesContractCode,
          CustomerSalesContractLineNo: customerSalesContractLineNo,
          SalesContractItem: contractItem,
        };
      } else {
        // undraw old quantity
        console.debug(
          `DrawProduct: We cannot draw due to insufficient balance! Therefore Undraw oldQty:${oldQty} and disassociate the Contract:${customerSalesContractCode} and ContractLine:${customerSalesContractLineNo}`
        );

        this.updateBalance(
          itemCode,
          -1 * oldQty,
          oldSalesUM,
          customerSalesContractCode,
          customerSalesContractLineNo
        );
        customerSalesContractCode = null;
        customerSalesContractLineNo = null;
      }
    }
    // if we cant consume this contract lets try for another, NEEDS SORTING
    console.debug(
      `DrawProduct: we cant consume existing contract. lets try for another.`
    );
    var sortedLines = this.CustomerSalesContractItems.sort((a, b) => {
      return new Date(a.StartDate) - new Date(b.StartDate)
        ? true
        : a.CustomerSalesContractCode - b.CustomerSalesContractCode
          ? true
          : a.CustomerSalesContractLineNo - b.CustomerSalesContractLineNo
            ? true
            : false;
    });

    let existingLineUsageForProduct = existingContractLineUsages.filter(
      (x) => x.ItemCode == itemCode && x.LineNo !== soLineNo
    );

    function filterUsedContractLine(item, newQty) {
      if (
        existingLineUsageForProduct.find(
          (x) =>
            x.CustomerSalesContractCode === item.CustomerSalesContractCode &&
            x.CustomerSalesContractLineNo ===
            item.CustomerSalesContractLineNo &&
            x.Balance < newQty
        )
      ) {
        return false;
      }

      return true;
    }

    // remove lines that are used by this SO already
    var contractsToConsume = sortedLines.filter(filterUsedContractLine);

    const aNewContractToConsume = contractsToConsume.find(
      (item) =>
        item.ProductCode === itemCode &&
        item.SalesUM.toUpperCase() === newSalesUM.toUpperCase() &&
        item.Balance >= newQty
    );

    if (aNewContractToConsume !== undefined) {
      console.debug(
        `DrawProduct: Found New Contract to consume => Contract:${aNewContractToConsume.CustomerSalesContractCode}, ContractLine:${aNewContractToConsume.CustomerSalesContractLineNo}, SalesUM:${aNewContractToConsume.SalesUM}`
      );
      if (customerSalesContractCode != null) {
        // undraw this
        console.debug(
          `DrawProduct: UnDrawProduct:${itemCode} oldQty:${oldQty} from the already associated Contract:${customerSalesContractCode}`
        );
        this.updateBalance(
          itemCode,
          -1 * oldQty,
          oldSalesUM,
          customerSalesContractCode,
          customerSalesContractLineNo
        );
      }
      console.debug(
        `DrawProduct: Now DrawProduct:${itemCode} newQty:${newQty} from the new found Contract:${aNewContractToConsume.CustomerSalesContractCode}, ContractLine:${aNewContractToConsume.CustomerSalesContractLineNo}`
      );
      contractItem = this.updateBalance(
        itemCode,
        newQty,
        newSalesUM,
        aNewContractToConsume.CustomerSalesContractCode,
        aNewContractToConsume.CustomerSalesContractLineNo
      );
      return {
        CustomerSalesContractCode:
          aNewContractToConsume.CustomerSalesContractCode,
        CustomerSalesContractLineNo:
          aNewContractToConsume.CustomerSalesContractLineNo,
        SalesContractItem: contractItem,
      };
    } else {
      console.debug(
        `DrawProduct: Could not find a Contract Association for:${itemCode} Qty:${newQty}`
      );
      const contractValidForProduct = contractsToConsume.find(
        (item) =>
          item.ProductCode === itemCode &&
          item.SalesUM.toUpperCase() === newSalesUM.toUpperCase()
      );

      return {
        FailedCustomerSalesContractCode: contractValidForProduct
          ? contractValidForProduct.CustomerSalesContractCode
          : null,
        CustomerSalesContractCode: 0,
        CustomerSalesContractLineNo: 0,
        SalesContractItem: null,
        MessageType: isSalesUMChanged ? "SalesUMChanged" : "SalesUMQtyChanged",
      };
    }
  }

  updateBalance(
    itemCode,
    qty,
    salesUM,
    customerSalesContractCode,
    customerSalesContractLineNo
  ) {
    var salesContractItem;

    this.CustomerSalesContractItems.forEach((item) => {
      if (
        item.ProductCode == itemCode &&
        item.SalesUM.toUpperCase() == salesUM.toUpperCase() &&
        item.CustomerSalesContractCode === customerSalesContractCode &&
        item.CustomerSalesContractLineNo === customerSalesContractLineNo
      ) {
        console.debug(
          `DrawProduct: Updating Balance for Contract:${customerSalesContractCode} ContractLine:${customerSalesContractLineNo}. Prev Balance:${item.Balance
          }, New Balance:${item.Balance - qty}, SalesUM:${salesUM}`
        );

        item.Balance = item.Balance - qty;
        salesContractItem = item;
      }
      // else if (
      //   item.CustomerSalesContractCode === customerSalesContractCode &&
      //   item.CustomerSalesContractLineNo === customerSalesContractLineNo
      // ) {
      //   item.Balance = item.Balance - qty;
      // }
    });

    // const allProductsForThisContract = this.CustomerSalesContractItems.filter(item => item.CustomerSalesContractCode === customerSalesContractCode && item.CustomerSalesContractLineNo === customerSalesContractLineNo);
    // allProductsForThisContract.forEach(element => { element.Balance - qty });
    return salesContractItem;
  }

  loadCustomerContractItems(customerCode, salesOrderCode, existingSoLines) {
    console.debug(
      `loadCustomerContractItems customerCode: ${customerCode}, salesOrderCode:${salesOrderCode}`
    );

    console.debug(
      `loadCustomerContractItems Existing So Lines:`,
      existingSoLines
    );

    let that = this;

    this.CustomerSalesContractItems = [];

    if (!customerCode) {
      return;
    }

    CustomerSalesContractService.getCustomerSalesContractItems(
      +customerCode,
      salesOrderCode
    )
      .then(function ({ data }) {
        if (data.value.length === 0) {
          console.debug("CustomerSalesContractItems not found");
          return;
        }
        console.debug("LoadCustomerContractItems DATA", data.value);

        const salesContractItems = data.value.map((item) => {
          var index = item.CustomerSalesContractLine.CustomerSalesContractItemConsumptions.findIndex(
            (x) => x.ProductCode == item.ProductCode
          );

          var available,
            balance = item.CustomerSalesContractLine.Quantity;

          if (index != -1) {
            var data =
              item.CustomerSalesContractLine
                .CustomerSalesContractItemConsumptions;
            available = data[index].Quantity - data[index].DrawnQuantity;
            balance = data[index].Quantity - data[index].DrawnQuantity;
          }

          return {
            CustomerSalesContractCode:
              item.CustomerSalesContractLine.CustomerSalesContractCode,
            CustomerSalesContractLineNo: item.CustomerSalesContractLine.LineNo,
            DefaultPrice: item.DefaultPrice,
            LineNo: item.CustomerSalesContractLine.LineNo,
            ProductCode: item.ProductCode,
            SalesUM: item.CustomerSalesContractLine.SalesUM,
            Description: item.CustomerSalesContractLine.Description,
            UseMarket: item.CustomerSalesContractLine.UseMarket,
            ApplyFreight: item.CustomerSalesContractLine.ApplyFreight,
            Quantity: item.CustomerSalesContractLine.Quantity,
            CustomerCode:
              item.CustomerSalesContractLine.CustomerSalesContract.CustomerCode,
            StartDate:
              item.CustomerSalesContractLine.CustomerSalesContract.StartDate,
            CustomerSalesContractLineDefaultPrice:
              item.CustomerSalesContractLine.DefaultPrice,
            CustomerSalesContractStatus:
              item.CustomerSalesContractLine.CustomerSalesContract.Status,
            Available: available,
            Balance: balance,
          };
        });

        that.CustomerSalesContractItems = salesContractItems;

        console.debug(
          "LoadCustomerContractItems mapped array",
          salesContractItems
        );
        if (salesOrderCode == "") {
          salesOrderCode = -1;
        }

        CustomerSalesContractService.getCustomerSalesContractSalesOrderConsumption(
          +salesOrderCode
        )
          .then(function ({ data: data2 }) {
            if (data2.length === 0) {
              console.debug(
                "getCustomerSalesContractSalesOrderConsumption not found"
              );
            }

            var existingContractLineUsages = existingSoLines
              .filter(
                (detail) =>
                  detail.CustomerSalesContractCode !== null &&
                  detail.CustomerSalesContractLineNo !== null
              )
              .map((detail) => ({
                CustomerSalesContractCode: detail.CustomerSalesContractCode,
                CustomerSalesContractLineNo: detail.CustomerSalesContractLineNo,
                ProductCode: detail.ItemCode,
                SalesUM: detail.SalesUM,
                SalesUMQty: detail.SalesUMQty,
              }));

            that.CustomerSalesContractItems = [];

            console.debug(
              "getCustomerSalesContractSalesOrderConsumption DATA",
              data2
            );

            salesContractItems.forEach((item) => {
              if (data2.length > 0) {
                // let item2 = data2.value.find(
                //   (item2) =>
                //     item2.CustomerSalesContractLineNo ==
                //     item.CustomerSalesContractLineNo &&
                //     item2.CustomerSalesContractCode ==
                //     item.CustomerSalesContractCode
                // );
                // if (item2) {
                //   item.Available = item.Quantity - item2.DrawnQuantity;
                //   item.Balance = item.Quantity - item2.DrawnQuantity;
                // }
              }

              let existingSOItems = existingContractLineUsages.filter(
                (item3) =>
                  item3.CustomerSalesContractLineNo ==
                  item.CustomerSalesContractLineNo &&
                  item3.CustomerSalesContractCode ==
                  item.CustomerSalesContractCode
              );

              let existingSOQtySum = existingSOItems.reduce(
                (accumulator, currentValue) =>
                  accumulator + currentValue.SalesUMQty,
                0
              );

              // if (existingSOItems) {
              //   item.Balance = item.Balance - existingSOQtySum;
              // }
              console.debug(
                `Updating balance for ${item.ProductCode} => Available: ${item.Available}, Balance: ${item.Balance}, existingSOQtySum: ${existingSOQtySum}`
              );
              that.addContract(item);
            });
          })
          .catch(function (error) {
            console.debug(
              "LoadCustomerContractItems => getCustomerSalesContractSalesOrderConsumption error",
              error
            );
          });
      })
      .catch(function (error) {
        console.debug("LoadCustomerContractItems error", error);
      });
  }
}
class CustomerSalesContractItem {
  constructor(params) {
    this.CustomerSalesContractCode = params.CustomerSalesContractCode;
    this.CustomerSalesContractLineNo = params.CustomerSalesContractLineNo;
    this.Description = params.Description;
    this.ProductCode = params.ProductCode;
    this.SalesUM = params.SalesUM;
    this.StartDate = params.StartDate;
    this.LineNo = params.LineNo;
    this.Available = params.Available;
    this.Balance = params.Balance;
    this.UseMarket = params.UseMarket;
    this.ApplyFreight = params.ApplyFreight;
    this.DefaultPrice = params.DefaultPrice;
    this.Quantity = params.Quantity;
    this.CustomerCode = params.CustomerCode;
    this.CustomerSalesContractStatus = params.CustomerSalesContractStatus;
    this.CustomerSalesContractLineDefaultPrice =
      params.CustomerSalesContractLineDefaultPrice;
  }
}

export { CustomerSalesContracts, CustomerSalesContractItem };
